export default function getMinuteFromPos(position: number) {
    return Math.floor((Math.abs(position) * 1440) / 2112);
}
